export default {
      id: "modify-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#modify-usage",
      toString: function () {
        return this.url;
      }
    }